import { getCompanyRiskKyc } from '@/api/Company';
import { useQuery } from '@tanstack/react-query';

export const useGetCompanyRiskKyc = (companyId?: number) =>
  useQuery({
    queryKey: ['companyRiskKyc', companyId],
    queryFn: () => getCompanyRiskKyc(companyId as number),
    enabled: !!companyId,
    refetchOnWindowFocus: false,
    select: (data) => data.data,
  });
